export type UserProfileMenu = "overview" | "voice" | "voice_self";

export {
    roleColorGradientToCss,
    roleColorToCss,
} from "../../../shared/roles/roleColors.js";

export type ProfileRole = {
    id: string;
    name: string;
    color?: number;
    colors?: {
        primaryColor?: number | null;
        primary_color?: number | null;
        secondaryColor?: number | null;
        secondary_color?: number | null;
        tertiaryColor?: number | null;
        tertiary_color?: number | null;
    } | null;
    position?: number;
};

export type ProfileBadge = {
    key: string;
    label: string;
    icon: string;
};

const DiscordBadgeLabels = new Map<string, { label: string; icon: string }>([
    [ "Staff", { label: "Discord Staff", icon: "verified_user" } ],
    [ "Partner", { label: "Partenaire Discord", icon: "handshake" } ],
    [ "Hypesquad", { label: "HypeSquad Events", icon: "emoji_events" } ],
    [ "BugHunterLevel1", { label: "Bug Hunter", icon: "bug_report" } ],
    [ "BugHunterLevel2", { label: "Bug Hunter Gold", icon: "pest_control" } ],
    [ "HypeSquadOnlineHouse1", { label: "Bravery", icon: "local_fire_department" } ],
    [ "HypeSquadOnlineHouse2", { label: "Brilliance", icon: "auto_awesome" } ],
    [ "HypeSquadOnlineHouse3", { label: "Balance", icon: "balance" } ],
    [ "PremiumEarlySupporter", { label: "Early Supporter", icon: "workspace_premium" } ],
    [ "TeamPseudoUser", { label: "Team Discord", icon: "groups" } ],
    [ "VerifiedBot", { label: "Bot vérifié", icon: "verified" } ],
    [ "VerifiedDeveloper", { label: "Développeur vérifié", icon: "code" } ],
    [ "CertifiedModerator", { label: "Modérateur certifié", icon: "shield" } ],
    [ "BotHTTPInteractions", { label: "Interactions HTTP", icon: "http" } ],
    [ "ActiveDeveloper", { label: "Active Developer", icon: "terminal" } ],
]);

export function sortProfileRoles<TRole extends ProfileRole>(roles: readonly TRole[]): TRole[] {
    return [ ...roles ].sort(compareProfileRoles);
}

function compareProfileRoles<TRole extends ProfileRole>(left: TRole, right: TRole): number {
    const positionDelta = (right.position || 0) - (left.position || 0);

    if (positionDelta !== 0)
        return positionDelta;

    return compareSnowflakesDescending(left.id, right.id);
}

function compareSnowflakesDescending(leftId: string, rightId: string): number {
    const left = BigInt(leftId);
    const right = BigInt(rightId);

    if (left === right)
        return 0;

    return left > right ? -1 : 1;
}

export function resolveUserProfileMenu(rawMenu: string | undefined): UserProfileMenu {
    if (rawMenu === "voice" || rawMenu === "voice_self")
        return rawMenu;

    return "overview";
}

export function isUserProfileVoiceMenu(menu: string | undefined): boolean {
    return resolveUserProfileMenu(menu) !== "overview";
}

export function getProfileBadges(isBot: boolean | undefined, rawBadges: readonly string[] | undefined): ProfileBadge[] {
    const badges = new Map<string, ProfileBadge>();

    if (isBot) {
        badges.set("bot", {
            key     : "bot",
            label   : "Bot",
            icon    : "smart_toy",
        });
    }

    for (const rawBadge of rawBadges ?? []) {
        const definition = DiscordBadgeLabels.get(rawBadge);

        badges.set(rawBadge, {
            key     : rawBadge,
            label   : definition?.label ?? rawBadge,
            icon    : definition?.icon ?? "military_tech",
        });
    }

    return [ ...badges.values() ];
}
